var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0a1 1 0 0 1 0 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h2a1 1 0 0 1 0 2H5a5.007 5.007 0 0 1-5-5V5a5.007 5.007 0 0 1 5-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.247 5.012a1 1 0 0 1 .703.28l3.88 3.88h-.005a4 4 0 0 1 0 5.655l-3.879 3.88a1 1 0 0 1-1.097.23 1.005 1.005 0 0 1-.622-.934 1 1 0 0 1 .305-.711l3.88-3.879a2 2 0 0 0 .333-.462c-.027.002-.05.017-.078.017l-15.678.031a1 1 0 0 1 0-2l15.684-.031c.015 0 .027.007.042.008a2 2 0 0 0-.3-.391l-3.879-3.879a1 1 0 0 1 .711-1.694"
  })));
};
export default SvgLogOut;